export default __webpack_public_path__ + "static/banner-ppc-1-3d07f2500beacd3946e6bf6b860a6b59.png";